function $a829c8942ca9775d$var$registerFlashCloseButtons() {
    const flashButtons = document.querySelectorAll(".notification .delete");
    for (const flashButton of flashButtons){
        if (flashButton.parentNode === null) throw new Error("invalid flash button");
        const flash = flashButton.parentNode;
        flash.addEventListener("click", ()=>{
            if (flash.parentNode === null) throw new Error("invalid flash message");
            flash.parentNode.removeChild(flash);
        });
    }
}
function $a829c8942ca9775d$var$registerNavCollapseButtons() {
    const navbarButtons = document.getElementsByClassName("navbar-burger");
    for (const navbarButton of navbarButtons)navbarButton.addEventListener("click", ()=>{
        if (!(navbarButton instanceof HTMLElement) || !navbarButton.dataset.target) throw new Error("invalid navbar button");
        const target = document.getElementById(navbarButton.dataset.target);
        if (target === null) throw new Error("could not find navbar button target");
        navbarButton.classList.toggle("is-active");
        target.classList.toggle("is-active");
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    $a829c8942ca9775d$var$registerFlashCloseButtons();
    $a829c8942ca9775d$var$registerNavCollapseButtons();
});


//# sourceMappingURL=index.694b22d6.js.map
